// @ts-nocheck
// File is retained for reference but no longer used in the codebase.
import { gql } from '@apollo/client';
import className from 'classnames/bind';
import { use, useEffect, useMemo, useRef, useState } from 'react';
import { ACFMediaFragment } from '@/fragments';
import { Image, InducteeHeroContent } from '@components';
import { Inductee3DHeroFragment } from '@graphqlTypes';
import ParallaxCanvas from '@/core/parallax-canvas';

import styles from './Inductee3DHero.module.scss';
import { useViewSize } from '@/providers/ViewSizeContext';
import { init } from '@graphql-codegen/cli';
import { getStringParam } from '@/utils/urlParams';
const cx = className.bind(styles);

type Inductee3DHeroProps = {
  data: Inductee3DHeroFragment['inducteeData']['inductee3dHero'];
  config: Inductee3DHeroFragment['inductee3dHeroConfig'];
  isPreview: boolean;
  inducteeInfo: {
    title: string;
    inductedBy?: string;
    category: string;
    class: string;
  }
};

export default function Inductee3DHero({ data, inducteeInfo, config, isPreview }: Inductee3DHeroProps) {
  const { headline, showReverb, mobileImage } = data;
  const canvasRef = useRef<HTMLDivElement>(null);
  const [hideContent, setHideContent] = useState(false);
  const [hideGradient, setHideGradient] = useState(false);
  const parallaxRef = useRef<ParallaxCanvas | null>(null);

  const { isTablet, isDesktop } = useViewSize();

  const showCanvas = useMemo(() => isTablet || isDesktop, [isTablet, isDesktop]);

  const canvasImages = useMemo(() => {
    return data?.images?.map(img => ({
      src: img?.image?.node?.mediaItemUrl || '',
      width: img?.image?.node?.mediaDetails.width || 0,
      height: img?.image?.node?.mediaDetails.height|| 0,
    })).filter(Boolean) || [];
  }, [data.images]);

  const onHideContent = (hide: boolean) => setHideContent(hide);
  const onHideGradient = (hide: boolean) => setHideGradient(hide);
  const showTools = getStringParam('showTools', 'false') === 'true';

  const initCanvas = () => {
    if (!canvasRef.current || !canvasImages.length) return;
    parallaxRef.current = new ParallaxCanvas({
      container: canvasRef.current,
      inducteeName: inducteeInfo.title,
      onHideContent,
      onHideGradient,
      useTool: isPreview || showTools, 
      images: canvasImages,
      config,
    });
  };

  useEffect(() => {
    if (!canvasRef.current || !canvasImages.length) return;
    initCanvas();
  }, [canvasRef, canvasImages]);

  useEffect(() => {
    if (!showCanvas && parallaxRef.current) {
      parallaxRef.current.dispose();
      parallaxRef.current = null;
    } else if (showCanvas && !parallaxRef.current) initCanvas();
  }, [showCanvas]);

  return (
    <section className={cx(["inductee-3d-hero", { 'hide-content': hideContent, 'hide-gradient': hideGradient }])}>
      <div className={cx("inductee-3d-hero__media")}>
        { showCanvas ? (
          <div className={cx("canvas")} ref={canvasRef} />
        ) : (
          <Image image={mobileImage} className={cx("mobile-image")} />
        )}
      </div>
      <InducteeHeroContent
        className={cx("hero-content")}
        headline={headline}
        inducteeInfo={inducteeInfo}
        showReverb={showReverb}
      />
    </section>
  )
}


// Inductee3DHero.fragments = {
//   entry: gql`
//     ${ACFMediaFragment}
//     fragment Inductee3DHero on Inductee {
//       inductee3dHeroConfig
//       inducteeData {
//         use3dHero
//         inductee3dHero {
//           showReverb
//           imageAttribution
//           headline {
//             line
//           }
//           mobileImage {
//             ...ACFMedia
//           }
//           images {
//             image {
//               ...ACFMedia
//             }
//           }
//         }
//       }
//     }
//   `
// };